export default __webpack_public_path__ + "static/media/Cost-benefit analysis methodology.7ceccafd.pdf";